import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarFull } from '../TopBarFull';
import { TopBarFullCtaColors } from '../TopBarFullEnums';
import MsftTeamsPromoImg from './imageComponents/MsftTeamsPromoImage';

const COPY = defineMessages({
  HEADLINE: {
    id: 'MsftTeamsIntegrationTopBarFull.headline',
    defaultMessage: 'Use Microsoft Teams?',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'MsftTeamsIntegrationTopBarFull.message',
    defaultMessage:
      'Try the native SurveyMonkey app to send a quick poll, quiz or pre-built survey.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'MsftTeamsIntegrationTopBarFull.ctaText',
    defaultMessage: 'Learn more',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

export const MsftTeamsIntegrationTopBarFull: React.FC = () => {
  return (
    <TopBarFull
      headline={t(COPY.HEADLINE)}
      message={t(COPY.MESSAGE)}
      image={() => <MsftTeamsPromoImg />}
      ctaText={t(COPY.CTA_TEXT)}
      ctaLink={createURL('/apps/VPV6PDLNXyscoDCcFChh2w_3D_3D/details/', {
        ut_source: 'ucs_popular_integrations',
      })}
      dismissable={true}
      ctaColor={TopBarFullCtaColors.alt}
    />
  );
};

export default MsftTeamsIntegrationTopBarFull;
